// ==================== 可复用 jQuery 插件 ====================
(function($) {
    'use strict';
    // ========== 全局共享配置与状态 ==========
    const CONFIG = {
        TOP_RATIO: 0.3,
        BOTTOM_RATIO: 0.70,
        SCROLL_OFFSET: 500
    };
    // 所有实例共享一个滚动状态（避免每个视频都绑定 scroll 事件）
    let scrollTicking = false;
    let resizeTimer = null;
    // 存储所有实例，用于全局滚动时批量处理
    const instances = [];
    // 全局滚动处理器（只绑定一次，性能最优）
    function onGlobalScroll() {
        if (scrollTicking) return;
        scrollTicking = true;
        requestAnimationFrame(() => {
            instances.forEach(instance => instance.checkViewport());
            scrollTicking = false;
        });
    }
    // 全局 resize 处理器（防抖）
    function onGlobalResize() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
            instances.forEach(instance => instance.checkViewport());
        }, 150);
    }
    // 只绑定一次全局事件
    $(window).on('scroll.videoPlayerGlobal', onGlobalScroll);
    $(window).on('resize.videoPlayerGlobal', onGlobalResize);
    // ========== 可见性检测工具函数（静态方法） ==========
    function isVisuallyHidden($el) {
        const el = $el[0];
        if (!el || !el.isConnected) return true;
        const style = getComputedStyle(el);
        if (style.display === 'none') return true;
        if (style.visibility === 'hidden' || style.visibility === 'collapse') return true;
        if (parseFloat(style.opacity) <= 0.01) return true;
        const rect = el.getBoundingClientRect();
        if (rect.width === 0 || rect.height === 0) return true;
        return false;
    }
    function isCoveredByOther($el) {
        if (isVisuallyHidden($el)) return true;
        const rect = $el[0].getBoundingClientRect();
        const cx = rect.left + rect.width / 2;
        const cy = rect.top + rect.height / 2;
        if (cx < 0 || cy < 0 || cx > window.innerWidth || cy > window.innerHeight) return true;
        const topEl = document.elementFromPoint(cx, cy);
        if (!topEl) return true;
        return !(topEl === $el[0] || $el[0].contains(topEl));
    }
    function shouldPauseVideo($video) {
        return isVisuallyHidden($video) || isCoveredByOther($video);
    }
    function isInActiveBand($el) {
        const rect = $el[0].getBoundingClientRect();
        const vh = window.innerHeight || document.documentElement.clientHeight;
        const bandTop = vh * CONFIG.TOP_RATIO;
        const bandBottom = vh * CONFIG.BOTTOM_RATIO;
        const overlapTop = Math.max(rect.top, bandTop);
        const overlapBottom = Math.min(rect.bottom, bandBottom);
        return Math.max(0, overlapBottom - overlapTop) > 0;
    }
    function isNearViewport($el, distance) {
        const rect = $el[0].getBoundingClientRect();
        return rect.top - distance <= window.innerHeight && rect.bottom + distance >= 0;
    }
    // ========== 视频播放器类 ==========
    class CustomVideoPlayer {
        constructor($container, options) {
            this.$container = $container;
            this.options = $.extend({
                videoId: $container.data('video-id') || 'video_' + Date.now(),
                playControl: false,      // 是否显示播放按钮
                voiceControl: true,      // 是否显示音量控制
                progress: true,          // 是否显示进度条
                lazySrc: '',             // 懒加载视频地址
                lazyOffset: 1000          // 懒加载提前量
            }, options);
            // 防止重复初始化
            if ($container.data('custom-video-initialized')) return;
            $container.data('custom-video-initialized', true);
            this.videoId = this.options.videoId;
            this.isDragging = false;
            this.isLoopRunning = false;
            this.lazyLoaded = false;
            this._initElements();
            this._initUI();
            this._bindEvents();
            this._setupLazyLoad();
            // 注册到全局实例列表
            instances.push(this);
            // 立即检查一次视口
            this.checkViewport();
        }
        // ---------- 元素初始化 ----------
        _initElements() {
            this.$video = this.$container.find('.custom_video_player_body');
            this.video = this.$video[0];
            this.$playBtn = this.$container.find('.custom_video_play_btn');
            this.$voiceBtn = this.$container.find('.custom_video_voice');
            this.$voiceOn = this.$voiceBtn.find('.voice_able_icon');
            this.$voiceOff = this.$voiceBtn.find('.voice_fobiden_icon');
            this.$progressWrap = this.$container.find('.progress-wrap');
            this.$progressBar = this.$container.find('.progress-bar');
            this.$progressThumb = this.$container.find('.progress-thumb');
        }
        // ---------- UI 初始化 ----------
        _initUI() {
            // 播放按钮
            if (this.options.playControl) {
                this.$playBtn.show();
            } else {
                this.$playBtn.hide();
            }
            // 音量按钮初始状态（默认静音，显示静音图标）
            if (this.options.voiceControl) {
                this.$voiceOn.hide();
                this.$voiceOff.show();
            } else {
                this.$voiceBtn.hide();
            }
            // 进度条
            if (!this.options.progress) {
                this.$container.find('.custom_progress_box').hide();
            }
            // 视频默认静音（兼容移动端自动播放）
            this.video.muted = true;
            this.video.playsInline = true;
        }
        // ---------- 事件绑定 ----------
        _bindEvents() {
            const self = this;
            // 播放按钮
            if (this.options.playControl) {
                this.$playBtn.on('click.videoPlayer', function(e) {
                    e.stopPropagation();
                    self.togglePlay();
                });
                this.$video.on('click.videoPlayer', function() {
                    self.togglePlay();
                });
            }
            // 音量控制
            if (this.options.voiceControl) {
                this.$voiceBtn.on('click.videoPlayer', function(e) {
                    e.stopPropagation();
                    self.toggleVoice();
                });
            }
            // 进度条
            if (this.options.progress) {
                this._bindProgressEvents();
            }
            // 视频状态事件
            this.$video
              .on('play.videoPlayer', () => this._startProgressLoop())
              .on('pause.videoPlayer', () => this._updateProgressUI())
            //   .on('ended.videoPlayer', () => this._resetProgressUI())
              .on('timeupdate.videoPlayer', () => this._timeupdate())
              .on('loadstart.videoPlayer', () => this._resetProgressUI())
              .on('emptied.videoPlayer', () => this._resetProgressUI())
              .on('loadedmetadata.videoPlayer', () => this._updateProgressUI())
              .on('durationchange.videoPlayer', () => this._updateProgressUI());
        }
        // ---------- 视口检测（核心） ----------
        checkViewport() {
            // 如果视频还没懒加载，不处理播放逻辑
            if (!this.lazyLoaded && this.options.lazySrc) return;
            const inBand = isInActiveBand(this.$video);
            const shouldPause = shouldPauseVideo(this.$video);
            if (inBand && !shouldPause) {
                this.video.play().catch(() => {});
                if (this.options.playControl) {
                    this.$playBtn.hide();
                }
            } else {
                this.video.pause();
                if (this.options.playControl) {
                    this.$playBtn.css('display', 'flex');
                }
            }
        }
        // ---------- 播放控制 ----------
        togglePlay() {
            if (this.video.paused) {
                this.video.play();
                this.$playBtn.hide();
            } else {
                this.video.pause();
                this.$playBtn.css('display', 'flex');
            }
        }
        // ---------- 音量控制 ----------
        toggleVoice() {
            this.video.muted = !this.video.muted;
            if (this.video.muted) {
                this.$voiceOn.hide();
                this.$voiceOff.show();
            } else {
                this.$voiceOn.show();
                this.$voiceOff.hide();
            }
        }
        // ---------- 进度条 ----------
        _bindProgressEvents() {
            const self = this;
            this.$progressWrap
              .on('pointerdown.videoPlayer', function(e) {
                  self.isDragging = true;
                  this.setPointerCapture(e.originalEvent.pointerId);
                  self._seekByEvent(e);
              })
              .on('pointermove.videoPlayer', function(e) {
                  if (!self.isDragging) return;
                  self._seekByEvent(e);
              })
              .on('pointerup.videoPlayer', function() {
                  self.isDragging = false;
              })
              .on('pointercancel.videoPlayer', function() {
                  self.isDragging = false;
              });
        }
        _seekByEvent(e) {
            const rect = this.$progressWrap[0].getBoundingClientRect();
            const clientX = e.originalEvent.touches ? e.originalEvent.touches[0].clientX : e.originalEvent.clientX;
            let ratio = (clientX - rect.left) / rect.width;
            ratio = Math.max(0, Math.min(1, ratio));
            if (this.video.duration && isFinite(this.video.duration)) {
                this.video.currentTime = ratio * this.video.duration;
            }
            this._setProgressUI(ratio);
        }
        _setProgressUI(ratio) {
            const pct = ratio * 100;
            this.$progressBar.css('width', pct + '%');
            // thumb 保持原有逻辑（display:none，拖拽时可能不需要显示）
        }
        _updateProgressUI() {
            if (this.isDragging) return;
            if (!this.video.duration || !isFinite(this.video.duration)) {
                this._resetProgressUI();
                return;
            }
            this._setProgressUI(this.video.currentTime / this.video.duration);
        }
        _resetProgressUI() {
            this.$progressBar.css('width', '0%');
        }
        _timeupdate() {
            if (this.video.duration && this.video.currentTime > this.video.duration - 0.1) {
                this.$progressBar.css('width', '0%');
            }
        }
        _startProgressLoop() {
            if (this.isLoopRunning) return;
            this.isLoopRunning = true;
            const self = this;
            const step = () => {
                if (self.video.paused || self.video.ended) {
                    self.isLoopRunning = false;
                    self._updateProgressUI();
                    return;
                }
                self._updateProgressUI();
                if ('requestVideoFrameCallback' in HTMLVideoElement.prototype) {
                    self.video.requestVideoFrameCallback(step);
                } else {
                    requestAnimationFrame(step);
                }
            };
            step();
        }
        // ---------- 懒加载 ----------
        _setupLazyLoad() {
            if (!this.options.lazySrc) {
                this.lazyLoaded = true;
                return;
            }
            // 如果已经在视口附近，直接加载
            if (isNearViewport(this.$container, this.options.lazyOffset)) {
                this._loadVideo();
                return;
            }
            // 否则等待滚动到附近
            const checkLazy = () => {
                if (this.lazyLoaded) return;
                if (isNearViewport(this.$container, this.options.lazyOffset)) {
                    this._loadVideo();
                    $(window).off('scroll.lazy-' + this.videoId, checkLazy);
                }
            };
            $(window).on('scroll.lazy-' + this.videoId, checkLazy);
        }
        _loadVideo() {
            this.video.src = this.options.lazySrc;
            this.video.load();
            this.lazyLoaded = true;
            // 加载后触发一次视口检查
            this.checkViewport();
        }
        // ---------- 销毁 ----------
        destroy() {
            // 从全局实例列表移除
            const idx = instances.indexOf(this);
            if (idx > -1) instances.splice(idx, 1);
            // 解绑所有事件
            this.$container.off('.videoPlayer');
            this.$video.off('.videoPlayer');
            this.$progressWrap.off('.videoPlayer');
            $(window).off('scroll.lazy-' + this.videoId);
            // 清理数据标记
            this.$container.removeData('custom-video-initialized');
        }
    }
    // ========== jQuery 插件封装 ==========
    $.fn.customVideoPlayer = function(options) {
        return this.each(function() {
            new CustomVideoPlayer($(this), options);
        });
    };
})(jQuery);